<div class="feedback-text-wrapper d-flex align-items-center p-3 m-1" [ngClass]="type">
  @if (type === 'loading') {
    <places-spinner [small]="true"></places-spinner>
  }
  @if (isIconAvaliable()) {
    <i class="material-icons pr-2">{{getIconName()}}</i>
  }
  <ng-content></ng-content>
</div>